<template>
  <loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" />
  <!-- EDITAR-->
  <div class="row">
    <div class="col-md-12">
      <div class="card card-primary">
        <div class="card-body">
          <div class="row">
            <!-- LEILOEIRO RESPONSÁVEL -->
            <div class="col-sm-12">
              <div class="form-group">
                <label for="endereco_cidade">Leiloeiro responsável</label>

                <select class="custom-select rounded-0" id="endereco_cidade" v-model="formData.leiloeiro_id" style="text-transform: uppercase">
                  <option v-for="leiloeiro in leiloeiros" :key="leiloeiro.id" :value="leiloeiro.id">
                    {{ leiloeiro.matricula + " - " + leiloeiro.nome }}
                  </option>
                </select>

                <span v-if="!formData.cadastrar_publicacao" style="color: red" v-for="error in v$.leiloeiro_id.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- NÚMERO PROCESSO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_numero">Número do processo</label>
                <input
                  class="form-control"
                  id="processo_numero"
                  v-model="formData.processo_numero"
                  @blur="upper('processo_classe')"
                  style="text-transform: uppercase"
                />

                <span v-if="!formData.cadastrar_publicacao" style="color: red" v-for="error in v$.processo_numero.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- NÚMERO REFERÊNCIA -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_referencia">Número de referencia</label>
                <input
                  class="form-control"
                  id="processo_referencia"
                  v-model="formData.processo_referencia"
                  @blur="upper('processo_referencia')"
                  style="text-transform: uppercase"
                />

                <span v-if="!formData.cadastrar_publicacao" style="color: red" v-for="error in v$.processo_referencia.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- EXEQUENTE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_exequente">Exequente</label>
                <input
                  class="form-control"
                  id="processo_exequente"
                  v-model="formData.processo_exequente"
                  @blur="upper('processo_exequente')"
                  style="text-transform: uppercase"
                />

                <span v-if="!formData.cadastrar_publicacao" style="color: red" v-for="error in v$.processo_exequente.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- EXECUTADO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_executado">Executado</label>
                <input
                  class="form-control"
                  id="processo_executado"
                  v-model="formData.processo_executado"
                  @blur="upper('processo_executado')"
                  style="text-transform: uppercase"
                />

                <span v-if="!formData.cadastrar_publicacao" style="color: red" v-for="error in v$.processo_executado.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- VARA -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_vara">Vara</label>
                <input
                  class="form-control"
                  id="processo_vara"
                  v-model="formData.processo_vara"
                  @blur="upper('processo_vara')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>

            <!-- CLASSE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="processo_classe">Classe processual</label>
                <input
                  class="form-control"
                  id="processo_classe"
                  v-model="formData.processo_classe"
                  @blur="upper('processo_classe')"
                  style="text-transform: uppercase"
                />

                <span v-if="!formData.cadastrar_publicacao" style="color: red" v-for="error in v$.processo_classe.$errors" :key="error.$uid">
                  {{ error.$message }}
                </span>
              </div>
            </div>

            <!-- ENDERECO ESTADO -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco_estado">Estado</label>

                <select
                  class="custom-select rounded-0"
                  id="endereco_estado"
                  v-model="formData.estado_id"
                  @change="buscarCidades()"
                  style="text-transform: uppercase"
                >
                  <option value=""></option>
                  <option v-for="estado in estados" :key="estado.id" :value="estado.id">
                    {{ estado.sigla }}
                  </option>
                </select>
              </div>
            </div>

            <!-- ENDERECO CIDADE -->
            <div class="col-sm-6">
              <div class="form-group">
                <label for="endereco_cidade">Cidade</label>

                <select class="custom-select rounded-0" id="endereco_cidade" v-model="formData.cidade_id" style="text-transform: uppercase">
                  <option value=""></option>
                  <option v-for="cidade in my_cidades" :key="cidade.id" :value="cidade.id">
                    {{ cidade.nome }}
                  </option>
                </select>
              </div>
            </div>
            <!-- DATA LEILOES 
            <div class="col-sm-12">
              <div class="form-group">
                <label for="processo_data_leiloes">Data dos leilões</label>
                <textarea
                  readonly="true"
                  class="form-control"
                  id="processo_data_leiloes"
                  placeholder="Data dos leilões"
                  v-model="formData.processo_data_leiloes"
                  rows="2"
                  cols="50"
                ></textarea>
              </div>
            </div>
-->
            <!-- ONUS 
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_onus">Ônus</label>
                <textarea
                  readonly="true"
                  class="form-control"
                  id="processo_onus"
                  placeholder="Ônus"
                  v-model="formData.processo_onus"
                  rows="2"
                  cols="50"
                  @blur="upper('processo_onus')"
                  style="text-transform: uppercase"
                ></textarea>
              </div>
            </div>
-->
            <!-- ADVOGADOS 
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_advogados">Advogados</label>
                <textarea
                  readonly="true"
                  class="form-control"
                  id="processo_advogados"
                  placeholder="Advogados"
                  v-model="formData.processo_advogados"
                  rows="2"
                  cols="50"
                  @blur="upper('processo_advogados')"
                  style="text-transform: uppercase"
                ></textarea>
              </div>
            </div>
-->
            <!-- LOCAL 
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_local_leilao">Local do leilão</label>
                <input
                  readonly="true"
                  class="form-control"
                  id="processo_local_leilao"
                  placeholder="Local do leilão"
                  v-model="formData.processo_local_leilao"
                  @blur="upper('processo_local_leilao')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>
-->
            <!-- JUIZ COMPLEMENTO 
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_juiz_complemento">Juiz complemento (Sr. Sra.)</label>
                <input
                  readonly="true"
                  class="form-control"
                  id="processo_juiz_complemento"
                  placeholder="Sr. Sra."
                  v-model="formData.processo_juiz_complemento"
                  @blur="upper('processo_juiz_complemento')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>
-->
            <!-- NOME DO JUIZ
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_juiz">Nome do Juiz</label>
                <input
                  readonly="true"
                  class="form-control"
                  id="processo_juiz"
                  placeholder="Sr. Sra."
                  v-model="formData.processo_juiz"
                  @blur="upper('processo_juiz')"
                  style="text-transform: uppercase"
                />
              </div>
            </div>
 -->
            <!-- DEPOSITÁRIO PÚBLICO 
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_depositario">Depositário público</label>
                <textarea
                  readonly="true"
                  class="form-control"
                  id="processo_depositario"
                  placeholder="Depositário público"
                  v-model="formData.processo_depositario"
                  rows="1"
                  cols="50"
                  @blur="upper('processo_depositario')"
                  style="text-transform: uppercase"
                ></textarea>
              </div>
            </div>
-->
            <!-- AVALIAÇÃO 
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_valor_avaliacao">Avaliação</label>
                <input
                  readonly="true"
                  class="form-control"
                  id="processo_valor_avaliacao"
                  placeholder="0.00"
                  v-model="formData.processo_valor_avaliacao"
                  type="number"
                  step="0.01"
                />
              </div>
            </div>
-->
            <!-- ORIGINÁRIO
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_valor_originario">Valor originário</label>
                <input
                  readonly="true"
                  class="form-control"
                  id="processo_valor_originario"
                  placeholder="0.00"
                  v-model="formData.processo_valor_originario"
                  type="number"
                  step="0.01"
                />
              </div>
            </div>
 -->
            <!-- DÉBITO 
            <div class="col-sm-3">
              <div class="form-group">
                <label for="processo_valor_debito">Valor do débito</label>
                <input
                  readonly="true"
                  class="form-control"
                  id="processo_valor_debito"
                  placeholder="0.00"
                  v-model="formData.processo_valor_debito"
                  type="number"
                  step="0.01"
                />
              </div>
            </div>
          --></div>
        </div>

        <div class="card-footer">
          <button type="submit" class="btn btn-primary" @click="validateFields()">Salvar</button>
          <a type="submit" href="/admin/processos" class="btn btn-danger" style="margin-left: 15px">Voltar</a>
        </div>
      </div>
    </div>
  </div>

  <!-- LEILÕES -->
  <div class="card card-primary">
    <div class="card-header">
      <h5 class="card-title" id="accordion">&nbsp; Leilões com esse processo</h5>
    </div>
    <div class="card-body table-responsive p-0">
      <table class="table table-hover">
        <thead>
          <tr>
            <th style="width: 5%">Id</th>
            <th style="">Titulo</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="leilao in leiloes" :key="leilao">
            <td>{{ leilao.id }}</td>
            <td>
              <!--
              <a href="#" data-toggle="modal" data-target="#detalhes-leilao-modal" @click="leilao_selecionado = leilao">
                {{ leilao.leilao_titulo }}
              </a>
              -->

              <a :href="'/admin/leilao/' + leilao.id">
                {{ leilao.leilao_titulo }}
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- PUBLICACOES -->
  <div class="card card-primary">
    <div class="card-header">
      <h5 class="card-title" id="accordion">
        &nbsp; Publicações oficiais &nbsp;
        <button
          data-toggle="modal"
          data-target="#cadastrar-publicacao"
          class="btn btn-primary btn-sm"
          style="margin-left: 15px"
          @click="clickcadastrarPublicacao(), (cadastrar_publicacao = true)"
          type="button"
        >
          Nova publicação
          <i class="fa fa-plus" style="margin-left: 5px"></i>
        </button>
      </h5>
    </div>

    <div class="card-body table-responsive p-0">
      <table class="table table-hover">
        <thead>
          <tr>
            <th style="width: 5%">Id</th>
            <th>Titulo (apagar)</th>
            <th>Processo (apagar)</th>
            <th>Leilão</th>
            <th>Lote (apagar)</th>
            <th>Link publicação</th>
            <th>Conteúdo</th>
            <th>Criação</th>
            <th>Atualização</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="publicacao in publicacoes" :key="publicacao">
            <td>{{ publicacao.id }}</td>
            <td>{{ publicacao.titulo }}</td>
            <td>{{ publicacao.processo_id }}</td>
            <td>
              <a :href="'/admin/leilao/' + publicacao.leilao_id">{{ publicacao.leilao_id }}</a>
            </td>
            <td>
              <a :href="'/admin/leilao/' + publicacao.leilao_id + '/lotes/editar/' + publicacao.lote_id">{{ publicacao.lote_id }}</a>
            </td>
            <td><a v-if="publicacao.edital_id" :href="'/' + publicacao.edital_id + '/publicacao'" target="_blank">Link publicação</a></td>
            <td>
              <button
                data-toggle="modal"
                data-target="#conteudo-publicacao"
                @click="publicacao_selecionada = publicacao"
                type="button"
                class="btn btn-primary btn-sm"
              >
                Conteúdo
                <i style="margin-left: 3px" class="fa fa-search"></i>
              </button>
            </td>
            <td>{{ formatDate(publicacao.created_at) }}</td>
            <td>{{ formatDate(publicacao.updated_at) }}</td>

            <td>
              <a
                id="navbarDropdown"
                class="nav-link"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                v-pre
              >
                <i class="fa-solid fa-bars" style="color: gray"></i>
              </a>

              <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right" aria-labelledby="navbarDropdown" ref="menu">
                <div class="dropdown-divider"></div>
                <a href="#" @click="deletarPublicacao(publicacao)" class="dropdown-item">
                  <i class="fa-solid fa-trash"></i>
                  &nbsp;&nbsp; Deletar
                </a>
                <div class="dropdown-divider"></div>
                <a href="#" @click="enviarEmail(publicacao)" class="dropdown-item">
                  <i class="fa-solid fa-pen"></i>
                  &nbsp;&nbsp; Enviar e-mail
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- MODAL CONTEÚDO PUBLICAÇÃO -->
  <div class="modal fade" id="conteudo-publicacao" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body" v-if="publicacao_selecionada">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>

            <!-- ID DO LEILÃO-->
            <span v-html="publicacao_selecionada.conteudo"></span>
          </div>

          <button data-dismiss="modal" class="btn btn-danger btn-sm">Fechar</button>
        </div>
      </div>
    </form>
  </div>

  <!-- MODAL DETALHES LEILÃO -->
  <div class="modal fade" id="detalhes-leilao-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="card">
              <div
                class="card-body"
                style="
                  padding: 0px 0px 0px 0px;
                  text-align: left;
                  font-family: 'Montserrat', sans-serif;
                  text-transform: uppercase;
                  margin: 0px 0px 0px 0px;
                "
              >
                <div style="text-align: left; line-height: 5px" class="p-2">
                  <div style="margin-top: 7px; position: relative">
                    <p style="font-size: 16px; font-weight: bold; word-wrap: break-word">
                      {{ leilao_selecionado.cidade }} - {{ leilao_selecionado.estado }}
                    </p>
                    <span style="font-size: 15px; font-weight: bold; margin-top: 4px">
                      {{ getFormatedTitle(leilao_selecionado.leilao_titulo) }}
                    </span>
                    <br />
                  </div>
                </div>

                <div style="line-height: 15px; margin-top: 5px; text-align: left" class="p-2">
                  <b style="font-size: 14px">
                    Modalidade:
                    <a style="color: #4a4949; font-weight: 400">{{ leilao_selecionado.leilao_1_modalidade }}</a>
                  </b>
                  <br />
                  <b style="font-size: 14px">
                    Local:
                    <a style="color: #4a4949; font-weight: 400; text-transform: none">{{ leilao_selecionado.leilao_local }}</a>
                  </b>
                </div>
                <!-- DATAS E VALORES DOS LEILÕES -->
                <div v-if="leilao_selecionado.leilao_num_pracas > 1 && !venda_direta" style="text-align: left; line-height: 15px" class="p-2">
                  <div style="font-size: 14px; color: #545353" :class="leilao_selecionado.leilao_1_realizado === 1 ? 'realizado' : ''">
                    <b>1º Leilão:</b>
                    {{ formatDate(leilao_selecionado.leilao_1_data) + "h" }}
                  </div>

                  <!-- DATA 2 -->
                  <div style="font-size: 14px; color: #545353" v-if="leilao_selecionado.leilao_num_pracas >= 2">
                    <b>2º Leilão:</b>
                    {{ formatDate(leilao_selecionado.leilao_2_data) + "h" }}
                  </div>

                  <!-- DATA 3 -->
                  <div style="font-size: 14px; color: #545353" v-if="leilao_selecionado.leilao_num_pracas >= 3">
                    <b>3º Leilão:</b>
                    {{ formatDate(leilao_selecionado.leilao_3_data) + "h" }}
                  </div>

                  <!-- DATA 4 -->
                  <div style="font-size: 14px; color: #545353" v-if="leilao_selecionado.leilao_num_pracas >= 4">
                    <b>4º Leilão:</b>
                    {{ formatDate(leilao_selecionado.leilao_4_data) + "h" }}
                  </div>
                </div>

                <!-- ÚNICO LEILÃO-->
                <div
                  v-else-if="leilao_selecionado.leilao_num_pracas == 1 && !venda_direta"
                  style="padding-left: 8px !important; text-align: left; line-height: 15px; margin-top: 5px"
                  class="p-1"
                >
                  <div
                    style="font-size: 14px; color: #545353; margin-bottom: 3px"
                    :class="leilao_selecionado.leilao_1_realizado === 1 ? 'realizado' : ''"
                  >
                    <b>Único leilão:</b>
                    {{ formatDate(leilao_selecionado.leilao_1_data) + "h" }}
                  </div>
                </div>

                <!-- VENDA DIRETA-->
                <div v-else-if="venda_direta" style="text-align: center; line-height: 15px; text-transform: none" class="p-1">
                  <p style="font-size: 14px; margin-top: 5px">{{ leilao_selecionado.leilao_local }}</p>
                  <div style="font-size: 14px; color: #545353" :class="leilao_selecionado.leilao_1_realizado === 1 ? 'realizado' : ''">
                    <b style="">Disponível até:</b>
                    {{ formatDate(leilao_selecionado.leilao_1_data) + "h" }}
                    <br />
                    <a>Pelo valor de</a>
                    R$ {{ toCurrency(lote_selecionado.lote_valor_1) }}
                  </div>
                </div>

                <!-- ID DO LEILÃO-->
                <span class="p-2" style="font-size: 15px; font-weight: bold; margin-top: 4px">Leilão ID {{ leilao_selecionado.leilao_id }}</span>

                <button
                  style="font-size: 12px; border-radius: 2px; margin-left: 5px; margin-bottom: 12px"
                  type="submit"
                  class="btn btn-default"
                  title="Habilitações"
                  alt="Habilitações"
                >
                  <div>
                    <i class="fa-solid fa-laptop"></i>
                    {{ leilao_selecionado.total_habilitacoes }}
                  </div>
                </button>
              </div>
            </div>

            <button data-dismiss="modal" class="btn btn-danger btn-sm">Fechar</button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- MODAL CADASTRAR PUBLICAÇÃO -->
  <div class="modal fade" id="cadastrar-publicacao" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="endereco_cidade">Leilão</label>

                  <select class="custom-select rounded-0" v-model="formData.leilao_id" style="text-transform: uppercase" @change="buscarLotes()">
                    <option v-for="leilao in leiloes" :key="leilao.id" :value="leilao.id">
                      {{ leilao.id }}
                    </option>
                  </select>

                  <span v-if="formData.cadastrar_publicacao" style="color: red" v-for="error in v$.leilao_id.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>
              <div class="col-sm-6" v-if="lotes">
                <div class="form-group">
                  <label for="endereco_cidade">Lote</label>

                  <select class="custom-select rounded-0" v-model="formData.lote_id" style="text-transform: uppercase">
                    <option value=""></option>
                    <option v-for="lote in lotes" :key="lote.id" :value="lote.id">
                      {{ lote.id }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- TÍTULO -->
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="endereco_cidade">Título</label>

                  <input
                    class="form-control"
                    id="processo_numero"
                    v-model="formData.titulo"
                    @blur="upper('titulo')"
                    style="text-transform: uppercase"
                  />

                  <span v-if="formData.cadastrar_publicacao" style="color: red" v-for="error in v$.titulo.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>

              <!-- CONTEÚDO -->
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="endereco_cidade">Conteudo</label>

                  <Editor
                    class="editor_prime"
                    style="background-color: white"
                    editorStyle="height: 200px;"
                    v-model="formData.conteudo"
                    id="conteudo_notificacao"
                  />

                  <span v-if="formData.cadastrar_publicacao" style="color: red" v-for="error in v$.conteudo.$errors" :key="error.$uid">
                    {{ error.$message }}
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <button @click="cadastrarPublicacao" class="btn btn-primary btn-sm">Salvar</button>
                <button
                  style="margin-left: 5px"
                  id="open_close_cadastrar_publicacao"
                  data-toggle="modal"
                  data-target="#cadastrar-publicacao"
                  class="btn btn-danger btn-sm"
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import sweetAlert from "../../controller/sweetAlert";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "vue-loading-overlay/dist/vue-loading.css";
import Loading from "vue-loading-overlay";
import moment from "moment";
import Editor from "primevue/editor";

import useVueLidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";

export default {
  mixins: [sweetAlert, Swal],

  props: ["estados", "cidades", "processo", "leiloeiros"],

  components: { Loading, Editor },

  data() {
    return {
      nome: "",
      isLoading: false,
      my_cidades: [],
      publicacoes: [],
      leiloes: [],
      lotes: [],
      publicacao_selecionada: "",
      leilao_selecionado: "",
      venda_direta: false,
      cadastrar_publicacao: false,
    };
  },

  setup() {
    const formData = reactive({
      leiloeiro_id: "",
      processo_numero: "",
      processo_referencia: "",
      processo_executado: "",
      processo_exequente: "",
      processo_comitente: "",
      processo_vara: "",
      processo_classe: "",
      processo_data_leiloes: "",
      processo_onus: "",
      processo_advogados: "",
      processo_local_leilao: "",
      processo_juiz_complemento: "",
      processo_juiz: "",
      processo_depositario: "",
      processo_valor_avaliacao: "",
      processo_valor_originario: "",
      processo_valor_debito: "",

      cidade_id: "",
      cidade_id: "",

      lote_id: "",
      leilao_id: "",
      titulo: "EDITAL",
      conteudo: "",
      cadastrar_publicacao: false,
    });

    const rules = computed(() => {
      let local_rules = {};

      if (!formData.cadastrar_publicacao) {
        local_rules.leiloeiro_id = { required };
        local_rules.processo_numero = { required };
        local_rules.processo_referencia = { required };
        local_rules.processo_executado = { required };
        local_rules.processo_exequente = { required };
        local_rules.processo_classe = { required };
      } else {
        local_rules.titulo = { required };
        local_rules.conteudo = { required };
        local_rules.leilao_id = { required };
      }

      return local_rules;
    });

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    this.my_cidades = this.cidades;

    this.formData.leiloeiro_id = this.processo.leiloeiro_id;
    this.formData.processo_numero = this.processo.processo_numero;
    this.formData.processo_referencia = this.processo.processo_referencia;
    this.formData.processo_executado = this.processo.processo_executado;
    this.formData.processo_exequente = this.processo.processo_exequente;
    this.formData.processo_comitente = this.processo.processo_comitente;
    this.formData.processo_vara = this.processo.processo_vara;
    this.formData.processo_classe = this.processo.processo_classe;
    this.formData.processo_data_leiloes = this.processo.processo_data_leiloes;
    this.formData.processo_onus = this.processo.processo_onus;
    this.formData.processo_advogados = this.processo.processo_advogados;
    this.formData.processo_local_leilao = this.processo.processo_local_leilao;
    this.formData.processo_juiz_complemento = this.processo.processo_juiz_complemento;
    this.formData.processo_juiz = this.processo.processo_juiz;
    this.formData.processo_depositario = this.processo.processo_depositario;
    this.formData.processo_valor_avaliacao = this.processo.processo_valor_avaliacao;
    this.formData.processo_valor_originario = this.processo.processo_valor_originario;
    this.formData.processo_valor_debito = this.processo.processo_valor_debito;
    this.formData.cidade_id = this.processo.cidade_id;
    this.formData.estado_id = this.processo.estado_id;

    this.buscarPublicacoes();
    this.buscarLeiloes();
  },

  methods: {
    enviarEmail(publicacao) {
      let html = "Deseja enviar e-mail sobre esta publicação? ";

      this.$swal
        .fire({
          title: "Confirmação",
          html: html,
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero enviar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              publicacao_id: publicacao.id,
            };

            console.log(publicacao);

            axios
              .post(`/admin/publicacao/send_email`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessageWithButton("Sucesso", "E-mail enviado com sucesso!");
              })
              .catch((error) => {
                this.isLoading = false;
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    deletarPublicacao(publicacao) {
      let html = "Deseja deletar esta publicação? ";

      this.$swal
        .fire({
          title: "Confirmação",
          html: html,
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              publicacao_id: publicacao.id,
            };

            axios
              .post(`/admin/publicacao/delete`, data)
              .then((response) => {
                this.isLoading = false;
                this.showSuccessMessageWithButtonAndReload("Sucesso", "Publicação deletada com sucesso!");
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    async validateFields() {
      const result = await this.v$.$validate();

      if (result) {
        this.update();
      } else {
        console.log(this.v$);
      }
    },

    getFormatedTitle(title) {
      if (title && title.length > 30) {
        return title.substring(0, 30) + "...";
      } else {
        return title;
      }
    },

    update() {
      this.isLoading = true;

      let data = {
        id: this.processo.id,
        leiloeiro_id: this.formData.leiloeiro_id,
        processo_numero: this.formData.processo_numero,
        processo_referencia: this.formData.processo_referencia,
        processo_executado: this.formData.processo_executado,
        processo_exequente: this.formData.processo_exequente,
        processo_comitente: this.formData.processo_comitente,
        processo_vara: this.formData.processo_vara,
        processo_classe: this.formData.processo_classe,
        processo_data_leiloes: this.formData.processo_data_leiloes,
        processo_onus: this.formData.processo_onus,
        processo_advogados: this.formData.processo_advogados,
        processo_local_leilao: this.formData.processo_local_leilao,
        processo_juiz_complemento: this.formData.processo_juiz_complemento,
        processo_juiz: this.formData.processo_juiz,
        processo_depositario: this.formData.processo_depositario,
        processo_valor_avaliacao: this.formData.processo_valor_avaliacao,
        processo_valor_originario: this.formData.processo_valor_originario,
        processo_valor_debito: this.formData.processo_valor_debito,
        cidade_id: this.formData.cidade_id,
        estado_id: this.formData.estado_id,
      };

      console.log("ATUALIZANDO");
      console.log(data);

      axios
        .post(`/admin/processo/update`, data)
        .then((response) => {
          this.isLoading = false;

          if (response.data.success) {
            this.showSuccessMessageWithButton("Sucesso", "Dados editados");
          } else {
            this.showErrorMessageWithButton("Ops....", response.data.msg);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    async cadastrarPublicacao() {
      const result = await this.v$.$validate();

      if (result) {
        this.isLoading = true;

        let data = {
          titulo: this.formData.titulo,
          conteudo: this.formData.conteudo,
          leilao_id: this.formData.leilao_id,
          lote_id: this.formData.lote_id,
          processo_id: this.processo.id,
        };

        console.log("ATUALIZANDO");
        console.log(data);

        axios
          .post(`/admin/publicacao/store`, data)
          .then((response) => {
            this.isLoading = false;

            if (response.data.success) {
              this.showSuccessMessageWithButtonAndReload("Sucesso!", "Publicação cadastrada");
            } else {
              this.showErrorMessageWithButton("Ops...", response.data.msg);
            }
          })
          .catch((error) => {
            this.isLoading = false;
            this.showErrorMessageWithButton("Ops..", error);
            console.log(error);
          });
      }
    },

    clickcadastrarPublicacao() {
      this.formData.cadastrar_publicacao = true;
      this.cadastrar_publicacao = true;

      this.buscarLeiloes();

      /*
      this.$nextTick(function () {
        let btn = document.getElementById("open_close_cadastrar_publicacao");
        btn.click();
      });
      */
    },

    buscarLeiloes() {
      let data = {
        processo_id: this.processo.id,
        inicio: 0,
        tamanho: 10000,
        order: "id",
      };

      console.log("Buscando leiloes");

      axios
        .post(`/admin/leilao/search`, data)
        .then((response) => {
          this.leiloes = response.data.leiloes;

          console.log(this.leiloes);
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },
    buscarLotes() {
      let data = {
        leilao_id: this.formData.leilao_id,
        inicio: 0,
        tamanho: 10000,
        processo_id: this.processo.id,
      };

      axios
        .post(`/admin/lotes/search`, data)
        .then((response) => {
          console.log("Lotes");
          console.log(response.data);

          this.lotes = response.data.lotes;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },
    buscarPublicacoes() {
      let data = {
        processo_id: this.processo.id,
        inicio: 0,
        tamanho: 10000,
      };

      axios
        .post(`/admin/publicacao/search`, data)
        .then((response) => {
          this.publicacoes = response.data.publicacoes;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    buscarCidades() {
      this.isLoading = true;

      let data = {
        estado_id: this.formData.estado_id,
      };

      console.log("CRIANDO");
      console.log(data);

      axios
        .post(`/admin/endereco/cidades_por_estado`, data)
        .then((response) => {
          this.my_cidades = response.data.cidades;

          this.formData.cidade_id = null;

          console.log(response.data);

          this.isLoading = false;
        })
        .catch((error) => {
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
          this.isLoading = false;
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1040px;
  margin-left: -250px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 900px;
    margin-left: -00px;
    margin-top: 100px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 1100px) {
  .modal-content {
    width: 900px;
    margin-left: -180px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 960px) {
  .modal-content {
    width: 750px;
    margin-left: -120px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
